import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import Loader from 'layout/atoms/Loader/Loader';
import OrderManagerItem from 'layout/atoms/OrderManagerItem/OrderManagerItem';
import Grid from 'layout/molecules/Grid/Grid';
import OrderManagerList from 'layout/molecules/OrderManagerList/OrderManagerList';
import { selectOrderDetailsItem, selectOrderDetailsStatus } from 'store/orderDetailsSlice';
import { fetchOrderProductionManagerData, resetOrderProductionManagerState, selectOrderProductionManagerData, selectOrderProductionManagerRefetchFlags, selectOrderProductionManagerStatus, } from 'store/orderProductionManagerSlice';
function ProductionManager() {
    var _a;
    const dispatch = useDispatch();
    const orderDetailsStatus = useSelector(selectOrderDetailsStatus);
    const pmStatus = useSelector(selectOrderProductionManagerStatus);
    const pmRefetchFlag = useSelector(selectOrderProductionManagerRefetchFlags).fetchOrderProductionManagerData;
    const orderItem = useSelector(selectOrderDetailsItem);
    const orderProductionManagerData = useSelector(selectOrderProductionManagerData);
    useEffect(() => {
        return () => {
            // Avoid showing stale data when navigating between orders / routes
            dispatch(resetOrderProductionManagerState());
        };
    }, [dispatch]);
    useEffect(() => {
        var _a;
        const hasDataForDifferentOrder = ((_a = orderProductionManagerData === null || orderProductionManagerData === void 0 ? void 0 : orderProductionManagerData.order) === null || _a === void 0 ? void 0 : _a.id) &&
            (orderItem === null || orderItem === void 0 ? void 0 : orderItem.id) &&
            orderProductionManagerData.order.id !== orderItem.id;
        if ((orderDetailsStatus.fetch === 'succeeded' &&
            (pmStatus.fetchOrderProductionManagerData === 'idle' || hasDataForDifferentOrder)) ||
            pmRefetchFlag) {
            dispatch(fetchOrderProductionManagerData(orderItem.id));
        }
    }, [
        dispatch,
        orderItem === null || orderItem === void 0 ? void 0 : orderItem.id,
        orderDetailsStatus.fetch,
        pmStatus.fetchOrderProductionManagerData,
        pmRefetchFlag,
        (_a = orderProductionManagerData === null || orderProductionManagerData === void 0 ? void 0 : orderProductionManagerData.order) === null || _a === void 0 ? void 0 : _a.id,
    ]);
    if (pmStatus.fetchOrderProductionManagerData === 'loading' ||
        pmStatus.fetchOrderProductionManagerData === 'idle') {
        return React.createElement(Loader, null);
    }
    if (pmStatus.fetchOrderProductionManagerData === 'failed') {
        return React.createElement("p", null, "error3");
    }
    return (React.createElement(Grid, { gap: 0, hp: 24, vp: 16 },
        React.createElement(OrderManagerList, null, orderProductionManagerData.specifications.map((spec) => {
            return (React.createElement(OrderManagerItem, { key: spec.specification.id, specificationData: spec, orderId: orderProductionManagerData.order.id }));
        }))));
}
export default memo(withRouter(ProductionManager));
